import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateLegalsRoutes = defineRoute({
    record: {
        route: {
            path: "/associate-legals",
            component: () => loadView(import("./AssociateLegalsTable.vue")),
        },
    },
    create: {
        route: {
            path: "/associate-legals/create",
            component: () => loadView(import("./AssociateLegalsCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/associate-legals/:id",
            component: () => loadView(import("./AssociateLegalsDetail.vue")),
        },
        build(id: string) {
            return `/associate-legals/${id}`;
        },
    },
});
